import React, { Component } from 'react';

class Home extends Component {
  render(){

    return(
      <div className="home-content">
        <div className="video-wrapper">
          <iframe width="420" height="315" src="https://www.youtube.com/embed/xebveLwv3Is" frameborder="0" allowfullscreen=""></iframe>
        </div>
        <h2 className="headline no-margin">Bowie</h2>
        <h2 className="headline no-margin">Elvis</h2>
        <h2 className="headline no-margin">Prince</h2>
        <h3 className="headline-secondary no-margin">Alternative & classic rock,<br/>blues, reggae,</h3>
        <div className="other">and other cool stuff...</div>
      </div>
    );
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/modules/pages/Home.js